<template>
  <div class="wrapper">
    <Header />

    <!-- Banner -->
    <div class="innerbannerwrap">
      <div class="innerbanner">
        <h2 class="bannerHeadline">about <span>us</span></h2>
      </div>
    </div>

    <!-- Section: Soccer Country Club -->
    <section class="matchSchedule countryclub">
      <div class="container">
        <div class="row">
          <h2 class="heading small">soccer <span>country club</span></h2>
          <p class="headParagraph">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil
            debitis mollitia qui libero voluptate ratione, molestias!
            Necessitatibus voluptatem temporibus doloremque non, vel ipsam,
            nesciunt dolores consequatur, est tempora ut! Est.
          </p>
        </div>
      </div>
    </section>

    <!-- Section: Board Members -->
    <section class="players">
      <div class="container">
        <div class="row">
          <h2 class="heading">board <span>members</span></h2>
          <p class="headParagraph">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Perferendis consequuntur animi, commodi, voluptatibus labore aperiam
            fugit maxime quos optio architecto cum? Laborum nesciunt doloribus
            expedita atque error rem molestias, ducimus.
          </p>

          <div class="wrapplayer clearfix">
            <ul class="boardmember clearfix">
              <li v-for="member in members" :key="member.id" class="clearfix">
                <div>
                  <div class="fig01">
                    <div
                      class="memberimg"
                      :style="{
                        background: `url(${member.image}) no-repeat top center`,
                      }"
                    ></div>
                  </div>
                  <div class="bg-black01 fig02">
                    <h6 class="paragraph02">{{ member.name }}</h6>
                    <p class="uppercaseheading red">{{ member.role }}</p>
                    <p>{{ member.bio }}</p>
                  </div>
                  <div class="bg-redcolor fig02">
                    <p>BORN {{ member.birth }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Club History -->
    <section class="club_history">
      <div class="container">
        <div class="row">
          <h2 class="heading">club <span>history</span></h2>
          <p class="headParagraph">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Perferendis consequuntur animi, commodi, voluptatibus labore aperiam
            fugit maxime quos optio architecto cum?
          </p>

          <div class="nav clubHistory-wrap clearfix">
            <ul class="historyMeter">
              <li
                v-for="(year, i) in historyYears"
                :key="i"
                :class="{ win: year.win, active: year.active }"
              >
                <a href="#"
                  ><span>{{ year.year }}</span></a
                >
              </li>
            </ul>

            <div class="tab-content historyVideoWrap clearfix">
              <div
                v-for="(item, i) in historyVideos"
                :key="i"
                class="tab-pane clearfix"
              >
                <div class="historyVideo">
                  <div class="historyvideoContainer">
                    <iframe :src="item.video" allowfullscreen></iframe>
                  </div>
                </div>
                <div class="historyContent">
                  <h4>
                    <span>{{ item.title }}</span> {{ item.subtitle }}
                  </h4>
                  <p>{{ item.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Achievements -->
    <section class="club_history achivementwrapper bg-white">
      <div class="container">
        <div class="row">
          <h2 class="heading">our <span>achievements</span></h2>
          <p class="headParagraph">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Perferendis consequuntur animi, commodi, voluptatibus labore aperiam
            fugit maxime quos optio architecto cum?
          </p>

          <div class="wrap-achive">
            <ul class="achievement">
              <li v-for="(achv, i) in achievements" :key="i" class="clearfix">
                <div class="fig">
                  <img :src="achv.image" :alt="achv.title" />
                  <div>{{ achv.caption }}</div>
                </div>
                <div class="figcontentachv">
                  <h5 class="headline01 red">{{ achv.title }}</h5>
                  <p>{{ achv.text }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

const members = [
  {
    id: 1,
    name: "Sammie Stoddard",
    role: "Director",
    image: "@/assets//images/boardMember/boardMember01.jpg",
    bio: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam officia labore molestias.",
    birth: "14 April 1975, England",
  },
  {
    id: 2,
    name: "Dominick Dumbleton",
    role: "CEO",
    image: "@/assets//images/boardMember/boardMember02.jpg",
    bio: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam officia labore molestias.",
    birth: "14 April 1975, England",
  },
  {
    id: 3,
    name: "Leland Lagos",
    role: "CEO",
    image: "@/assets//images/boardMember/boardMember03.jpg",
    bio: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam officia labore molestias.",
    birth: "14 April 1975, England",
  },
];

const historyYears = [
  { year: 1987 },
  { year: 1988, win: true },
  { year: 1991, win: true, active: true },
  { year: 2000, win: true },
  { year: 2012, win: true },
  { year: 2015, win: true },
];

const historyVideos = [
  {
    video: "https://www.youtube.com/embed/rPEd-h8DdRI",
    title: "fifa 1991,",
    subtitle: "uefa champions league",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam non voluptatibus error a esse maiores.",
  },
  {
    video: "https://www.youtube.com/embed/F6U5-B3NUKA",
    title: "fifa 2000,",
    subtitle: "uefa champions league",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Numquam non voluptatibus error a esse maiores.",
  },
];

const achievements = [
  {
    image: "@/assets//images/awards/awards01.png",
    caption: "WINNER 2007, UEFA Champions League",
    title: "Winner 2007, UEFA Champions League",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam unde veniam rerum rem voluptates reprehenderit.",
  },
  {
    image: "@/assets//images/awards/awards03.png",
    caption: "WINNER 2000, UEFA Champions League",
    title: "Winner 2000, UEFA Champions League",
    text: "The UEFA Champions League is a seasonal association football competition established in 1955...",
  },
];
</script>
